function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0-2h130v130H0z",
  fill: "none"
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 65,
  cy: 63,
  r: 56
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  "data-name": "b",
  cx: 65,
  cy: 63,
  r: 56,
  fill: "#fff",
  stroke: "#12123b",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M95.76 44.17s1.14 3.91 1.2 4.26a1.56 1.56 0 01-.29 1.12 12 12 0 01-.79 1S61.73 85.42 61.17 86a10.79 10.79 0 01-3.78 1.74 10.62 10.62 0 01-3.88.12s-18.34-4.95-18.81-5.25a1.51 1.51 0 01-.6-.89l-1-3.63 4.75-.47 23.3-2.91 17-17.61 6.58-5.64s5.62-4.41 5.68-4.6 5.35-2.69 5.35-2.69z",
  fill: "#d0d2d3"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.61 82.19l34.83-35.47a2.25 2.25 0 00.56-1.55 2.37 2.37 0 00-1.66-2.27c-.38-.11-18.79-4.83-18.79-4.83a6 6 0 00-1.7 0 16.13 16.13 0 00-1.64.36c-.38.11-1.36.43-1.66.57a5.34 5.34 0 00-1.18.73c-.24.2-35.4 35.72-35.4 35.72a2.78 2.78 0 00-.97 1.79 2.46 2.46 0 00.41 1.63 2.06 2.06 0 00.87.71c.34.09 18.63 5.07 19.08 5.16a7.08 7.08 0 002.64-.19 14.84 14.84 0 002.4-.77 9.3 9.3 0 001.43-.85c.31-.24.78-.74.78-.74z",
  fill: "#f4f4f7"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#58595b",
  d: "M37.89 73.68l23.08 6.07 29.67-30.33-22.8-6.11-29.95 30.37z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 46.96,
  cy: 79.32,
  rx: 2.8,
  ry: 1.65,
  transform: "rotate(-15.46 46.965 79.34)",
  fill: "#d0d2d3"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.3 64.31c-1.06-.29-1.64-.83-1.73-1.61a2.88 2.88 0 011.29-2.41l5.62-4.83a9.12 9.12 0 013.72-1.86 7.44 7.44 0 013.89-.13c1.1.31 1.69.87 1.75 1.69a3.13 3.13 0 01-1.42 2.5l-5.75 4.8a9 9 0 01-3.62 1.76 7.29 7.29 0 01-3.75.09z",
  fill: "#fff"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.83 57.87a1.52 1.52 0 01.76 0 .4.4 0 01.35.33.59.59 0 01-.26.49l-1.38 1.17c-1.3 1.14-1.92 2.27-1.79 3.36s.94 1.84 2.42 2.25a10.21 10.21 0 005.24-.13 12.4 12.4 0 005.06-2.45l1.43-1.18a1.9 1.9 0 01.74-.36 1.52 1.52 0 01.76 0c.22.06.33.17.34.33a.6.6 0 01-.27.48l-1.43 1.16a15.79 15.79 0 01-6 3 14.47 14.47 0 01-6.39.47L57 68l3.07.85a.38.38 0 01.33.31.51.51 0 01-.25.46 1.64 1.64 0 01-.7.34 1.56 1.56 0 01-.74 0l-7.62-2.12c-.21 0-.32-.16-.34-.31a.52.52 0 01.24-.46 1.6 1.6 0 01.69-.34 1.41 1.41 0 01.73 0l3.06.84 1.39-1.17c-1.57-.63-2.37-1.6-2.41-2.91s.72-2.67 2.3-4l1.37-1.2a1.87 1.87 0 01.71-.42z",
  fill: "#fff"
});

var SvgIcVoice = function SvgIcVoice(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

export default "data:image/svg+xml;base64,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";
export { SvgIcVoice as ReactComponent };